import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CibilStage } from "../d2c.interface";

/**
 * Handles navigation across the D2C flow based on stage values.
 * This ensures stage-driven routing is consistent and centralized.
 */
@Injectable({ providedIn: "root" })
export class StageNavigationService {
    constructor(private router: Router) {}

    handle(stage: string): void {
        if (!stage) return;

        switch (stage) {
            case CibilStage.REQUEST_REGISTRATION:
                this.router.navigate(["/d2c/request-registration"]);
                break;

            case CibilStage.REQUEST_ALTER_NUMBER:
                this.router.navigate(["/d2c/login"]);
                break;

            case CibilStage.SUBMIT_OTP:
            case CibilStage.RESEND_OTP:
            case CibilStage.RESUBMIT_OTP:
                this.router.navigate(["/d2c/login-otp"]);
                break;

            case CibilStage.SUBMIT_OTP_EMAIL:
            case CibilStage.RESEND_OTP_EMAIL:
            case CibilStage.RESUBMIT_OTP_EMAIL:
                this.router.navigate(["/d2c/email-otp"]);
                break;

            case CibilStage.GET_CIBIL_DATA:
            case CibilStage.FETCH_CIBIL_DATA:
            case CibilStage.NO_HISTORY:
            case CibilStage.NO_DATA_FOUND:
                this.router.navigate(["/d2c/details"]);
                break;

            default:
                break;
        }
    }
}
